import { dateFormatter } from '@/utils/formatters/date';

export interface DayLabel {
  weekday: string;
  dayMonth: string;
}

const capitalize = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1);

export const formatDayLabel = (isoDate: string): DayLabel => {
  const isToday = dateFormatter(isoDate, 'YYYY-MM-DD') === dateFormatter(new Date(), 'YYYY-MM-DD');
  const weekdayShort = dateFormatter(isoDate, 'weekday');
  return {
    weekday: isToday ? 'Hoje' : capitalize(weekdayShort),
    dayMonth: dateFormatter(isoDate, 'DD/MM'),
  };
};
